import React from 'react';
import * as MaterialIcons from '@mui/icons-material';
import CustomIcons from './customIcons';

export const MaterialIcon = ({ iconName, showDefaultIcon = true, ...props }) => {
  const Icon = MaterialIcons[iconName] ? MaterialIcons[iconName] : CustomIcons[iconName];

  if (!Icon) {
    return showDefaultIcon ? <MaterialIcons.HelpOutlineOutlined {...props} /> : null;
  }

  return <Icon {...props} />;
};
